import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const GolfCourseBar = () => {
  const [activeImage, setActiveImage] = useState(0);

  const facilityData = {
    name: 'Golf Course',
    category: 'Sports',
    description: '9-hole championship golf course with professional coaching available.',
    longDescription: 'Our 9-hole championship golf course offers a challenging yet enjoyable experience for golfers of all skill levels. With well-manicured fairways, strategically placed bunkers, and stunning views, it provides the perfect setting for a round of golf. Professional coaching is available for beginners and those looking to improve their game.',
    images: [
      getImagePath('images/bars/golf-course-bar.jpg'),
      getImagePath('images/bars/golf-course-bar.jpg'),
      getImagePath('images/bars/golf-course-bar.jpg')
    ],
    icon: 'fa-golf-ball',
    capacity: '72 players',
    hours: 'Daily: 6am - 6pm',
    features: [
      '9-Hole Course',
      'Pro Shop',
      'Driving Range',
      'Golf Carts',
      'Putting Green',
      'Club Rental',
      'Professional Coaching',
      'Tournament Hosting'
    ],
    amenities: ['Clubhouse', 'Locker Rooms', 'Practice Facilities', 'Golf Simulator'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'golf@nlngraclub.com',
      extension: '107'
    },
    services: ['Lessons', 'Club Fitting', 'Equipment Sales', 'Tournaments'],
    pros: ['PGA Professional on Staff']
  };

  return (
    <div className="facility-detail-page">
      {/* Hero Section */}
      <section className="facility-detail-hero">
        <div className="hero-background">
          <img src={facilityData.images[0]} alt={facilityData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/facilities" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Facilities
            </Link>
            <span className="facility-category">{facilityData.category}</span>
            <h1 className="facility-title">{facilityData.name}</h1>
            <p className="facility-subtitle">{facilityData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Facility Content */}
      <section className="facility-content-section">
        <div className="container">
          <div className="facility-grid">
            {/* Left Column - Images */}
            <div className="facility-gallery">
              <div className="main-image">
                <img 
                  src={facilityData.images[activeImage]} 
                  alt={facilityData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {facilityData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${facilityData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="facility-details">
              <div className="detail-section">
                <h2>About {facilityData.name}</h2>
                <p className="facility-description">{facilityData.longDescription}</p>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {facilityData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <h4>Hours</h4>
                  <p>{facilityData.hours}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <h4>Capacity</h4>
                  <p>{facilityData.capacity}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-phone"></i>
                  <h4>Contact</h4>
                  <p>{facilityData.contact.phone} ext. {facilityData.contact.extension}</p>
                </div>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Services:</span>
                  <span className="info-value">{facilityData.services.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Professional:</span>
                  <span className="info-value">{facilityData.pros.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-calendar-check"></i> Book a Tee Time
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-envelope"></i> Golf Lessons
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GolfCourseBar;